import React from "react";
import styles from "./styles.module.scss";
import ResourceRow from "./ResourceRow";
import { useDispatch } from "react-redux";
import { deselectEvent } from "app/actions/events";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";
import CountdownTimer from "app/components/CountdownTimer";
import { formatFullDate, formatTime } from "app/utils/luxonFormats";
import useCalendarPreferences from "app/utils/hooks/useCalendarPreferences";

const TimeSlotReservationInfo = ({ event }) => {
  const { t } = useTranslation();
  const { preferences } = useCalendarPreferences();
  const intervalTimeString = `${formatTime(event.interval.start, preferences.timeFormat)} - ${formatTime(event.interval.end, preferences.timeFormat)} ${event.timeZoneShortString}`;

  const dispatch = useDispatch();

  let paymentTypeDisplay;
  switch (event.payment_method) {
    case "checkout_session":
      paymentTypeDisplay = t("Online");
      break;
    case "invoice":
      paymentTypeDisplay = t("Invoice");
      break;
    case "pending_selection":
      paymentTypeDisplay = t("Pending");
      break;
    default:
      paymentTypeDisplay = null;
  }

  return (
    <>
      <div className={styles.header}>
        <div className={styles.event_title}>
          <p>{event.title}</p>
          <div className={styles.repeat}>{t("Session Reservation")}</div>
        </div>
        <div className={styles.header_actions}>
          <a onClick={() => dispatch(deselectEvent())}>
            <i className="ico ico-x" />
          </a>
        </div>
      </div>
      <div className={styles.card_info_wrapper}>
        <div className={styles.event_subtitle}>
          <i className="ico ico-calendar"></i>
          <span>{formatFullDate(event.date, preferences.dateFormat)}</span>
        </div>
        <div className={styles.event_subtitle}>
          <i className="ico ico-clock"></i>
          <span>{intervalTimeString}</span>
        </div>
        <ResourceRow scheduleResources={event.scheduleResources} />

        <div className={styles.payment_info_wrapper}>
          <div className={styles.event_subtitle}>
            <i className={cls("ico ico-online-payment")} />
            <p>{paymentTypeDisplay}</p>
          </div>
          {!event.expires_at && <CountdownTimer expiresAt={event.expiresAt} />}
        </div>
      </div>
    </>
  );
};

export default TimeSlotReservationInfo;
